// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseLayout_container__pHsIa","mobileOnly":"BaseLayout_mobileOnly__j6p0E","desktopOnly":"BaseLayout_desktopOnly__JWM09","content":"BaseLayout_content__c30BI"};